import { Input } from "antd";
import OTPInput from "react-otp-input";

const OtpInput = ({ value, onChange, disabled, wrong = false }) => {
  return (
    <div className={`otpContainer ${wrong ? 'shake' : ''}`}>
      <OTPInput
        value={value}
        onChange={onChange}
        inputType="number"
        numInputs={4}
        shouldAutoFocus={true}
        containerStyle={{
          width: '100%',
          marginBottom: 20,
          justifyContent: 'space-between',
        }}
        inputStyle={{
          width: '20%',
          borderRadius: 16,
          height: 64,
          fontSize: 18,
          fontWeight: 'bold',
        }}
        renderInput={(props) => <Input disabled={disabled} style={{}} {...props} />}
      />
    </div>
  );
};

export default OtpInput;